import { type HttpClient } from '@/application/interfaces/http-client';

import { getOrderById } from './get-order-by-id';
import { getPendingSaleOrders } from './get-pending-sale-orders';
import { getSaleOrders } from './get-sale-orders';

const SaleOrderService = (httpClient: HttpClient.Instance) => ({
  getPendingSaleOrders: getPendingSaleOrders(httpClient),
  getSaleOrders: getSaleOrders(httpClient),
  getOrderById: getOrderById(httpClient),
});

export default SaleOrderService;
